import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./buttonIcon.html";
class C360buttonIcon extends LightningElement {
  constructor(...args) {
    super(...args);
    /** @type {string} */
    this.iconButtonName = void 0;
    /** @type {string} */
    this.iconButtonVariant = void 0;
    /** @type {string} */
    this.iconDescription = void 0;
    /** @type {() => void} */
    this.changeBlur = void 0;
    /** @type {() => void} */
    this.changeFocus = void 0;
  }
  onFocus(event) {
    event.preventDefault();
    if (this.changeFocus) {
      this.changeFocus();
    }
  }
  onBlur(event) {
    event.preventDefault();
    if (this.changeBlur) {
      this.changeBlur();
    }
  }
  /*LWC compiler v7.1.3*/
}
C360buttonIcon.delegatesFocus = true;
_registerDecorators(C360buttonIcon, {
  publicProps: {
    iconButtonName: {
      config: 0
    },
    iconButtonVariant: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    changeBlur: {
      config: 0
    },
    changeFocus: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(C360buttonIcon, {
  tmpl: _tmpl,
  sel: "c360-button-icon",
  apiVersion: 62
});
export default __lwc_component_class_internal;